export const apiUrl: string = `${window.location.origin}/api/User/`;
export const returnUrlByEnvironment: string = `${window.location.origin}/authentication/login`;
export const logoutUrl: string = `${window.location.origin}/authentication/logout`;
export const appleWalletapiUrl: string = `${window.location.origin}/api/User/Pass`;
